






























import Button from '@/components/common/button.vue';
import { useRecommend, RecommendContentType } from '@/hooks/use-recommend';
import { useStampStore } from '@/store/stamp';
import { ScreenDialog } from '@tencent/wphk-ui';
import { computed, defineComponent, ref, toRefs, watch, watchEffect } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';
import { DetailDialogType, useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';
import { MultiJumpContainer, MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';

export default defineComponent({
  name: 'RecommendDialog',
  components: {
    Button,
    ScreenDialog,
    MultiJumpContainer,
  },
  setup() {
    const stampStore = useStampStore();
    const { userTotalCount } = storeToRefs(stampStore);
    const recommendHook = useRecommend();
    const { showDialogByBanner: showCouponTaskDialog } = useCouponTaskDialog();

    const { extraInfo, contentType, contentImg, biTag } = toRefs(recommendHook.recommendInfoData);
    const { isReady } = toRefs(recommendHook.showData);
    // 推荐弹窗
    const recommendDialog = ref<ScreenDialog | null>(null);
    // 等待jumpInfo数据ready之后再渲染
    const isRenderMultiJump = ref(false);

    // 决定推荐弹窗的展示与隐藏
    watch(recommendHook.showData, () => {
      if (recommendHook.showData.isShow) {
        recommendDialog.value!.show();
      } else {
        recommendDialog.value!.hide();
      }
    });
    watch(isReady, () => {
      if (isReady) {
        // 推荐模块初始化结束后，进行埋点（包括空白对照组，实验组）
        const { isShow } = recommendHook.showData;
        biBrow('recommend.recommendModule_ready', {
          fisShow: String(isShow),
          ...biExt.value as any,
        });
      }
    });

    // 上报的拓展字段
    const biExt = computed(() => {
      const ext = {
        ftag: biTag?.value,
        fstampCnt: userTotalCount.value,
      };

      return ext;
    });

    // 跳转H5 或 拉起小程序 信息
    const jumpInfo = computed((): MultiJumpInfo => ({
      jumpUrl: extraInfo?.value?.jumpUrl,
      /** 拉起小程序，AppId，账号原始ID和AppID二选一即可 */
      appid: extraInfo?.value?.miniAppId,
      /** 拉起小程序，账号原始ID，账号原始ID和AppID二选一即可 */
      username: extraInfo?.value?.miniAppUsername,
      /** 拉起小程序，页面路径, 不填则默认跳转小程序主页 */
      path: extraInfo?.value?.miniAppPath,
    }));

    // MultiJumpContainer组件emit时，携带的返回数据
    const extraData = computed(() => {
      const { couponId, taskId } = toRefs(extraInfo?.value ?? {});
      const typeMap = {
        [RecommendContentType.coupon]: DetailDialogType.coupon, // 优惠券
        [RecommendContentType.task]: DetailDialogType.task, // 任务
      };
      return {
        id: couponId?.value || taskId?.value,
        dailogType: typeMap[contentType?.value ?? ''],
      };
    });
    watchEffect(() => {
      isRenderMultiJump.value = !!jumpInfo.value.jumpUrl || !!jumpInfo.value.username || !!extraData.value.id;
    });

    // 点击“立即兑换”
    const eGoExchange = (extra) => {
      recommendDialog.value?.hide();
      const { id, dailogType } = extra ?? {};
      showCouponTaskDialog(id, dailogType);
    };

    // 点击关闭
    const handleClose = () => {
      biClick('recommend.recommendDialog_close|关闭推荐弹窗', biExt.value as any);
    };

    return {
      biTag,
      contentImg,
      handleClose,

      isRenderMultiJump,
      jumpInfo,
      extraData,

      recommendDialog,
      biExt,
      eGoExchange,
    };
  },
});
